const EDIT_DONATION_DRAFT_PREFIX = 'admin:donationDraft:edit:'
export const NEW_DONATION_DRAFT_KEY = 'admin:donationDraft:new'
const DONATION_IMAGE_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg']
export const DONATION_IMAGE_FILE_ACCEPT = 'image/png,image/jpeg,image/jpg'
export const DONATION_IMAGE_FILE_ERROR_MESSAGE = 'png, jpg, jpeg 형식의 이미지만 업로드할 수 있습니다.'

// 포인트 기부 상품 이미지는 기존 운영 기준인 PNG/JPG/JPEG MIME type만 통과시킨다.
export const isDonationImageFile = (file) => {
    return Boolean(file) && DONATION_IMAGE_FILE_TYPES.includes(file.type)
}

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const hasExplicitValue = (value) => value !== undefined && value !== null

const normalizeTextValue = (value, fallbackValue = '') => {
    if (value === undefined || value === null) {
        return fallbackValue
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 포인트 기부 상품 폼은 이미지 파일을 제외한 텍스트/숫자 입력값만 sessionStorage에 남긴다.
export const createDonationDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            title: normalizeTextValue(params.title),
            brandName: normalizeTextValue(params.brandName),
            description: normalizeTextValue(params.description),
            point: normalizeTextValue(params.point),
            sortOrder: normalizeTextValue(params.sortOrder, '0'),
            status: normalizeNumberValue(params.status, 1),
        }
    }
}

// 이전 query 기반 draft 링크도 한 번은 복구할 수 있게, 실제로 들어온 값만 draft payload로 변환한다.
export const createLegacyDonationDraftPayload = (legacyParams = {}) => {
    const nextParams = {}

    if (hasExplicitValue(legacyParams.title)) nextParams.title = normalizeTextValue(legacyParams.title)
    if (hasExplicitValue(legacyParams.brandName)) nextParams.brandName = normalizeTextValue(legacyParams.brandName)
    if (hasExplicitValue(legacyParams.description)) nextParams.description = normalizeTextValue(legacyParams.description)
    if (hasExplicitValue(legacyParams.point)) nextParams.point = normalizeTextValue(legacyParams.point)
    if (hasExplicitValue(legacyParams.sortOrder)) nextParams.sortOrder = normalizeTextValue(legacyParams.sortOrder, '0')
    if (hasExplicitValue(legacyParams.status)) nextParams.status = normalizeNumberValue(legacyParams.status, 1)

    return Object.keys(nextParams).length > 0 ? { params: nextParams } : null
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 포인트 기부 상품 작성 흐름을 이어간다.
export const applyDonationDraft = ({ baseParams = {}, draft }) => {
    if (!draft) {
        return {
            params: {
                ...baseParams,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            title: draftParams.title === undefined
                ? baseParams.title
                : normalizeTextValue(draftParams.title),
            brandName: draftParams.brandName === undefined
                ? baseParams.brandName
                : normalizeTextValue(draftParams.brandName),
            description: draftParams.description === undefined
                ? baseParams.description
                : normalizeTextValue(draftParams.description),
            point: draftParams.point === undefined
                ? baseParams.point
                : normalizeTextValue(draftParams.point),
            sortOrder: draftParams.sortOrder === undefined
                ? baseParams.sortOrder
                : normalizeTextValue(draftParams.sortOrder, '0'),
            status: draftParams.status === undefined
                ? baseParams.status
                : normalizeNumberValue(draftParams.status, normalizeNumberValue(baseParams.status, 1)),
        },
    }
}

export const createEditDonationDraftKey = (donationProductId) => `${EDIT_DONATION_DRAFT_PREFIX}${donationProductId}`

export const readDonationDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveDonationDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearDonationDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
